<template>
  <div class="cnehl-main" :style="{ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'}">
    <div class="urgency" :style="{
      'width': `${90 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${12 * zoomLevel}px`,
      'left': `${220 * zoomLevel}px`, }">
      {{ job['Urgent'] == '1' ? 'URGENT!!' : '' }}
    </div>
    <div class="printed-on" :style="{
      'width': `${330 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${12 * zoomLevel}px`,
      'left': `${325 * zoomLevel}px`, }">
      PRINTED ON: {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy') }} - {{ $dateTime.getDateTime(new Date(), 'HH:mm') }}
    </div>
    <div class="by" :style="{
      'width': `${140 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${12 * zoomLevel}px`,
      'left': `${660 * zoomLevel}px`, }">
      BY: {{ job['userid'] }}
    </div>
    <div class="reprint" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${29 * zoomLevel}px`,
      'left': `${660 * zoomLevel}px`, }">
      {@Reprint} <!-- Key needed!!! -->
    </div>
    <div class="fumigation" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${47 * zoomLevel}px`,
      'left': `${660 * zoomLevel}px`, }">
      {{ cn['Fumigation'] == '1' ? 'FUMIGATION' : '' }}
    </div>
    <div class="last-day" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${25 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${104 * zoomLevel}px`,
      'left': `${660 * zoomLevel}px`, }">
      {{ getLastDay() }}
    </div>
    <div class="office-hour" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${25 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${134 * zoomLevel}px`,
      'left': `${660 * zoomLevel}px`, }">
      {{ cn['OfficeHours'] ? cn['OfficeHours'] == '1' ? 'OFFICE HOURS' : '24 HOURS' : '' }}
    </div>
    <div class="rot-no" :style="{
      'width': `${299 * zoomLevel}px`,
      'height': `${25 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${104 * zoomLevel}px`,
      'left': `${51 * zoomLevel}px`, }">
      ROT No: {{ job['Request No'] }}
    </div>
    <div class="cust-ref-no" :style="{
      'width': `${240 * zoomLevel}px`,
      'height': `${25 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${134 * zoomLevel}px`,
      'left': `${51 * zoomLevel}px`, }">
      {{ job['Cust Ref No'] }}
    </div>
    <div class="pickup" :style="{
      'width': `${299 * zoomLevel}px`,
      'height': `${39 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${183 * zoomLevel}px`,
      'left': `${51 * zoomLevel}px`, }">
      {{ cn['PickUp'] }}
    </div>
    <div class="contact-person" :style="{
      'width': `${218 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${223 * zoomLevel}px`,
      'left': `${132 * zoomLevel}px`, }">
      {Contact Person} <!-- Key needed!!! -->
    </div>
    <div class="tel" :style="{
      'width': `${278 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${237 * zoomLevel}px`,
      'left': `${72 * zoomLevel}px`, }">
      {Tel} <!-- Key needed!!! -->
    </div>
    <div class="cn-no" :style="{
      'width': `${204 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${183 * zoomLevel}px`,
      'left': `${365 * zoomLevel}px`, }">
      {{ cn['ConsignmentNo'] }}
    </div>
    <div class="datetime" :style="{
      'width': `${179 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${183 * zoomLevel}px`,
      'left': `${580 * zoomLevel}px`, }">
      {{ Date.parse(job['Last Update']) ? $dateTime.getDateTime(new Date(job['Last Update']), 'dd/MM/yyyy HH:mm') : '' }}
    </div>
    <div class="datetime-required" :style="{
      'width': `${394 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${228 * zoomLevel}px`,
      'left': `${365 * zoomLevel}px`, }">
      {{ Date.parse(cn['RequiredTime']) ? `${$dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy HH:mm')} {Req Time Desc}` : '' }} <!-- Key needed!!! -->
    </div>
    <div class="deliver-to" :style="{
      'width': `${299 * zoomLevel}px`,
      'height': `${39 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${274 * zoomLevel}px`,
      'left': `${51 * zoomLevel}px`, }">
      {Deliver} <!-- Key needed!!! -->
    </div>
    <div class="contact-person-del" :style="{
      'width': `${218 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${311 * zoomLevel}px`,
      'left': `${132 * zoomLevel}px`, }">
      {Contact Person Del} <!-- Key needed!!! -->
    </div>
    <div class="tel-del" :style="{
      'width': `${278 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${325 * zoomLevel}px`,
      'left': `${72 * zoomLevel}px`, }">
      {Tel Del} <!-- Key needed!!! -->
    </div>
    <div class="ladenMT-dropoff" :style="{
      'width': `${395 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${271 * zoomLevel}px`,
      'left': `${364 * zoomLevel}px`, }">
      {{ cn['DropOff'] }}
    </div>
    <div class="size-type" :style="{
      'width': `${202 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${315 * zoomLevel}px`,
      'left': `${365 * zoomLevel}px`, }">
      {{ cn['ContSize'] }} {{ cn['ContType'] }}
    </div>
    <div class="seal" :style="{
      'width': `${180 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${315 * zoomLevel}px`,
      'left': `${579 * zoomLevel}px`, }">
      {{ cn['SealNo'] }}
    </div>
    <div class="cont-no" :style="{
      'width': `${300 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${356 * zoomLevel}px`,
      'left': `${50 * zoomLevel}px`, }">
      {{ cn['ContainerNo'] }}
    </div>
    <div class="cont-operator" :style="{
      'width': `${397 * zoomLevel}px`,
      'height': `${23 * zoomLevel}px`,
      'font-size': `${14 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${355 * zoomLevel}px`,
      'left': `${362 * zoomLevel}px`, }">
      {{ cn['ContOperator'] }}
    </div>
    <div class="commodity" :style="{
      'width': `${709 * zoomLevel}px`,
			'height': `${23 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${394 * zoomLevel}px`,
			'left': `${50 * zoomLevel}px`, }">
      {{ cn['Commodity'] }}
    </div>
    <div class="vessel-name" :style="{
      'width': `${351 * zoomLevel}px`,
			'height': `${23 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${432 * zoomLevel}px`,
			'left': `${49 * zoomLevel}px`, }">
      {{ job['Vessel Name'] }} - {{ job['Voy No'] }}
    </div>
    <div class="vessel-code" :style="{
      'width': `${347 * zoomLevel}px`,
			'height': `${23 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${429 * zoomLevel}px`,
			'left': `${411 * zoomLevel}px`, }">
      {{ job['Vessel No'] }} - {{ Date.parse(job['POD ETA']) ? $dateTime.getDateTime(new Date(job['POD ETA']), 'dd/MM/yyyy HH:mm') : '' }}
    </div>
    <div class="loading-port" :style="{
      'width': `${709 * zoomLevel}px`,
			'height': `${23 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${472 * zoomLevel}px`,
			'left': `${50 * zoomLevel}px`, }">
      {{ job['LoadDischargePort'] }}
    </div>
    <div class="shipper-forwarder" :style="{
      'width': `${710 * zoomLevel}px`,
			'height': `${23 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${506 * zoomLevel}px`,
			'left': `${49 * zoomLevel}px`, }">
      {Shipper} / {Forwarder}
    </div>
    <div class="requested-by" :style="{
      'width': `${710 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${544 * zoomLevel}px`,
			'left': `${49 * zoomLevel}px`, }">
      {{ job['Requested By'] }}
    </div>
    <div class="shipping-agent" :style="{
      'width': `${710 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${569 * zoomLevel}px`,
			'left': `${49 * zoomLevel}px`, }">
      Shipping Agent: {{ job['Shipping Agt Name'] }}
    </div>
    <div class="remarks" :style="{
      'width': `${350 * zoomLevel}px`,
			'height': `${32 * zoomLevel}px`,
			'font-size': `${14 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${616 * zoomLevel}px`,
			'left': `${48 * zoomLevel}px`, }">
      {{ cn['Remarks'] }}
    </div>
    <div class="job-type" :style="{
      'width': `${345 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${609 * zoomLevel}px`,
			'left': `${420 * zoomLevel}px`, }">
      Job Type: {{ job['Job Type'] }}
    </div>
    <div class="handling" :style="{
      'width': `${345 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${619 * zoomLevel}px`,
			'left': `${420 * zoomLevel}px`, }">
      {{ cn['HandlingType'] }}
    </div>
    <div class="bookingrefno" :style="{
      'width': `${345 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${629 * zoomLevel}px`,
			'left': `${420 * zoomLevel}px`, }">
      {{ job['Booking Ref No'] }}
    </div>
    <div class="gatepass" :style="{
      'width': `${710 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${639 * zoomLevel}px`,
			'left': `${420 * zoomLevel}px`, }">
      Gate Pass: {Gatepass}
    </div>
    <div class="delivery-type" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${994 * zoomLevel}px`,
			'left': `${40 * zoomLevel}px`, }">
      {{ cn['DeliveryType'] == 'SL' ? 'SIDELOADER' : '' }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      job: {},
      cn: {},
    }
  },
  props: {
    data: { type: Object, default: function() { return {}; }},
    printData: { type: Object, default: function() { return {}; }},

    properties: { type: Object, default: function() { return null; }},
    zoomLevel: { type: Number, default: 1 },
    fontPtPx: { type: Number, default: 1 },
    print: { type: Boolean, default: false },
  },
  methods: {
    getLastDay: function() {
      if (this.job['CN Job Type'] == 'EXP' || this.job['CN Job Type'] == '1-EXP') {
        let etaDate = Date.parse(this.job['POD ETA']);
        if (etaDate) {
          return this.$dateTime.getDateTimeDifferenceByDay(new Date(), etaDate) == 0 ? 'LAST DAY' : '';
        } else { return '' }
      } else { return '' }
    },
  },
  mounted() {
    this.job = this.properties['details'] ? this.properties['details'] : {};
    this.cn = this.properties['cns'] ? this.properties['cns'] : {};
  },
  watch: {
  }
}
</script>

<style scoped>
/* div { border: 1px solid gray; } */
</style>